import script from "./inventoryBatchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryBatchForm.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryBatchForm.vue?vue&type=style&index=0&id=12995c12&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12995c12"]])

export default __exports__